/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-underscore-dangle
  (window as any).__Zone_disable_customElements = true;
}
